const kvstore = require('kvstore');

const GENERIC_ERROR_MESSAGE = 'Sorry, there was a technical error. Please try again.';

const messages = {
	GENERIC_ERROR_MESSAGE
};

const error = (msg, opts) => {
	kvstore.call('$emit', 'message-error', msg, opts);
};
const success = msg => {
	kvstore.call('$emit', 'message-success', msg);
};
const message = msg => {
	kvstore.call('$emit', 'message', msg);
};

module.exports = {
	error,
	success,
	message,
	messages
};
